import { createReducer } from '@reduxjs/toolkit';
import { GetDisassembleInput, GetDisassembleRecipt, GetDisassembleBatch, postDisassembleIT, GetDisassembleIssue, postDisassembleReceipt, GetDisassembleReciptList } from './DisassembleThunk';

// Utility function to handle pending, fulfilled, and rejected actions
const handleAsyncActions = (builder, action, stateKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[stateKey] = true; // Set loading for specific API
      state[stateKey] = null; 
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request is fulfilled
      state[stateKey] = action.payload; // Set the fulfilled data
      state.error[errorKey] = null; // Reset error
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request fails
      state.error[errorKey] = action.payload; // Set specific error message for the API call
    });
};

const initialState = {
  // Data state for each API
  DisassembleData: null,
  DisassembleRecipt: null,
  DisassembleReciptList: null,
  DisassembleIssue: null,
  DisassembleBatch: null,
  DisassambleITPost: null,
  postDisassemble:null,

  // Dynamic loading and error states for each API
  loading: {
    DisassembleData: false,
    DisassembleRecipt: false,
    DisassembleReciptList: false,
    DisassembleBatch: false,
    DisassambleITPost: false,
    DisassembleIssue: false,
    postDisassemble:false
  },

  error: {
    DisassembleDataError: null,
    DisassembleReciptErr: null,
    DisassembleReciptListErr: null,
    DisassembleBatchError: null,
    DisassambleITPostError: null,
    DisassembleIssueError: null,
    postDisassembleError: null
  }
};

export const DisassembleReducer = createReducer(initialState, (builder) => {
  // Handle async actions using the utility function
  handleAsyncActions(builder, GetDisassembleInput, "DisassembleData", "DisassembleDataError");
  handleAsyncActions(builder, GetDisassembleRecipt, "DisassembleRecipt", "DisassembleReciptErr");
  handleAsyncActions(builder, GetDisassembleReciptList, "DisassembleReciptList", "DisassembleReciptListErr");
  handleAsyncActions(builder, GetDisassembleBatch, "DisassembleBatch", "DisassembleBatchError");
  handleAsyncActions(builder, postDisassembleIT, "DisassambleITPost", "DisassambleITPostError");
  handleAsyncActions(builder, GetDisassembleIssue, "DisassembleIssue", "DisassembleIssueError");
  handleAsyncActions(builder, postDisassembleReceipt, "postDisassemble", "postDisassembleError");
});

export default DisassembleReducer;

